// extracted by mini-css-extract-plugin
module.exports = {"link":"SocialLink-module--link--TwQyT","icon":"SocialLink-module--icon--2aeig"};